import React from "react";
import {Helmet} from "react-helmet";

function EditRegistration() {
   return (
      <div>
         <Helmet>
            <title>Edit Registration - Camp Connect</title>
         </Helmet>
         {/* <Navbar/> */}
         <br></br>
         <br></br>
         <br></br>
         <h1>This will be the future  Edit Registration page</h1>
         <center>
            <p>Please use the browser back button to return</p>
         </center>
      </div>
   )
};

export default EditRegistration;
